import { CSTable } from '@nextgen-web-framework/all';
import TableComponentProptype from './types/propTypes';

const TableComponent: React.FC<TableComponentProptype> = ({
  theme,
  columnList,
  footer,
  rowData,
  title,
}: TableComponentProptype) => (
  <CSTable
    title={title}
    theme={theme}
    columnList={columnList}
    footer={footer}
    rowData={rowData}
    configLabel={{
      columnLabel: 'name',
      rowLabel: 'data',
    }}
  />
);
export default TableComponent;
